import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import {AideType} from '../../../interface/api/AideType';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-modal-add-type-aide',
    templateUrl: './modal-add-type-aide.component.html',
    styleUrls: ['./modal-add-type-aide.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, FormsModule, MatDialogActions, MatDialogClose]
})
export class ModalAddTypeAideComponent implements OnInit {
    data = inject(MAT_DIALOG_DATA);

    public item = {} as AideType;


    ngOnInit() {}
}
